import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import FoodKeepApp from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <FoodKeepApp />
  </StrictMode>,
);
